import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {MatListModule} from '@angular/material/list';
import {MatLineModule} from '@angular/material/core';
import {MatDividerModule} from '@angular/material/divider';
import {GraphMap, GraphNode} from '../api/interfaces/graph-node.interface';
import {CommonModule} from '@angular/common';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {debounceTime, skip, Subscription} from 'rxjs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {Router} from '@angular/router';
import {ToursService} from '../api/services/tour.service';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SelectInputComponent} from '../shared/forms/select-input/select-input.component';
import {StoreService} from '../api/services/store.service';
import {NotificationService} from '../services/notification.service';
import {UserService} from '../api/services/user.service';
import {ThumbnailService} from '../api/services/thumbnail.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialog} from '@angular/material/dialog';
import {CreateNewMapDialogComponent} from './create-new-map-dialog.component';
import {PreviewService} from '../api/services/preview.service';
import {SettingsService} from '../api/services/setting.service';
import {CyPreviewComponent} from '../shared/components/cy-preview/cy-preview.component';
import {TopToolbarStateService} from '../nav/top-toolbar-state.service';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'maporium-store-browser',
  styleUrls: ['./map-list.bottomsheet.component.scss'],
  styles: [`
    :host {
      display: block;
      min-width: 800px;
      max-width: 90vw;
    }

    .dialog-header {
      border-radius: 4px 4px 0 0;
    }

    .store-content {
      padding-top: 0;
    }

    .owner-name, .owner-link {
      color: #888;
      cursor: pointer;
    }

    .owner-name:hover, .owner-link:hover {
      color: #666;
      text-decoration: underline;
    }
    .list-container {
      position: relative;
      min-height: 100px;
    }
    .list-container.loading {
      opacity: 0.5;
      pointer-events: none;
    }
    .inline-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
    }
    .view-toggle {
      display: flex;
      border: 1px solid #000;
      border-radius: 6px;
      overflow: hidden;
      height: 25px;
      font-size: 16px;
      background-color: white;
    }

    .view-toggle .toggle-part {
      padding: 0 4px;
      width: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: transparent;
      transition: background-color 0.2s ease;
    }

    .view-toggle .toggle-part.active {
      background-color: #e7f1fa;
    }

    .view-toggle .toggle-part:first-child {
      border-right: 1px solid black;
    }

    .view-toggle .toggle-part mat-icon {
      font-size: 18px;
      width: 18px;
      height: 18px;
    }
    .thumbnail-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      padding: 16px 0;
      max-height: 60vh;
      overflow-y: auto;
    }
    .thumbnail-card {
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      overflow: hidden;
      transition: box-shadow 0.2s;
      background: #fff;
    }
    .thumbnail-card:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
    .thumbnail-image {
      aspect-ratio: 16/9;
      background: #f5f5f5;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .thumbnail-image img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #f5f5f5;
    }
    .no-thumbnail {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 48px;
      color: #ccc;
    }
    .thumbnail-info {
      padding: 12px 12px 6px 12px;
      background-color: #f6faff;
      border-top: 1px solid #e0e0e0;
    }
    .thumbnail-info .name {
      display: block;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .thumbnail-info .owner {
      display: block;
      font-size: 12px;
      color: #888;
      padding-left: 28px;
    }
    .thumbnail-actions {
      padding: 0 12px 8px 12px;
      display: flex;
      justify-content: flex-end;
      gap: 4px;
      background-color: #f6faff;
    }
    ::ng-deep .thumbnail-actions .mat-mdc-icon-button {
      width: 32px !important;
      height: 32px !important;
      padding: 4px !important;
    }
    ::ng-deep .thumbnail-actions .mat-mdc-icon-button .mat-mdc-button-touch-target {
      width: 32px !important;
      height: 32px !important;
    }
  `],
  template: `
    <div class="d-flex justify-content-between align-items-center dialog-header">
      <h2 class="align-items-center d-flex m-0 p-0">
        <span class="icon-smap-function-store me-2"></span>
        {{ 'STORE_BROWSER.TITLE' | translate }}
      </h2>
      <span class="icon-smap-action-close close-button"
            (click)="close()"
            [matTooltip]="'SHARE_DIALOG.CLOSE_TOOLTIP' | translate"></span>
    </div>

    <div class="store-content">
    <div class="d-flex align-items-center justify-content-between py-2">
      <input type="text"
             [placeholder]="'TOOLBAR.SEARCH' | translate"
             class="col-4"
             id="search-input"
             #searchInput
             autocomplete="off"
             autocapitalize="off"
             autocorrect="off"
             spellcheck="false"
             [formControl]="searchControl">
      <span>{{ getMapCountLabel() }}</span>
      <div class="view-toggle">
        <div class="toggle-part"
             [class.active]="viewMode === 'list'"
             (click)="setViewMode('list')"
             [matTooltip]="'STORE_BROWSER.LIST_VIEW' | translate"
             role="button">
          <mat-icon class="material-symbols-rounded">view_list</mat-icon>
        </div>
        <div class="toggle-part"
             [class.active]="viewMode === 'grid'"
             (click)="setViewMode('grid')"
             [matTooltip]="'STORE_BROWSER.GRID_VIEW' | translate"
             role="button">
          <mat-icon class="material-symbols-rounded">view_module</mat-icon>
        </div>
      </div>
      <app-select-input [formControl]="filtersControl"
                        [blankValue]="'STORE_BROWSER.FILTER_BY' | translate"
                        [noMargin]="true"
                        [dropdownColSize]="20"
                        [isIcon]="false"
                        class="d-flex"
                        [noIcons]="true"
                        [options]="filterOptions">
      </app-select-input>
    </div>
    <mat-divider></mat-divider>

    @if (isInitialLoading) {
      <div class="d-flex justify-content-center align-items-center py-5">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      <div class="list-container" [class.loading]="isLoading">
        @if (isLoading) {
          <div class="inline-spinner">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        }
        @if (filteredMaps.length === 0 && !isLoading) {
          <div class="d-flex flex-column justify-content-center align-items-center py-5 text-muted">
            <span class="material-symbols-rounded mb-2" style="font-size: 48px;">storefront</span>
            <p class="mb-0">{{ 'STORE_BROWSER.NO_SMAPS_FOUND' | translate }}</p>
            <p class="small">{{ 'STORE_BROWSER.ADJUST_SEARCH_HINT' | translate }}</p>
          </div>
        } @else if (filteredMaps.length > 0) {
          @if (viewMode === 'grid') {
            <div class="thumbnail-grid" #thumbnailGrid>
              @for (map of filteredMaps; track map.id) {
                <div class="thumbnail-card"
                     [attr.data-map-id]="map.id"
                     #cardRef>
                  <div class="thumbnail-image">
                    @if (livePreviewsEnabled && getPreviewNodes(map.id)) {
                      <cy-preview [nodes]="getPreviewNodes(map.id)!"
                                  [mapStyles]="map.styles"></cy-preview>
                    } @else if (livePreviewsEnabled && isLoadingPreview(map.id)) {
                      <mat-spinner diameter="30"></mat-spinner>
                    } @else if (getThumbnailUrl(map)) {
                      <img [src]="getThumbnailUrl(map)" [alt]="map.name">
                    } @else {
                      <div class="no-thumbnail">
                        <span [ngClass]="getMapIcon(map)"></span>
                      </div>
                    }
                  </div>
                  <div class="thumbnail-info">
                    <div class="d-flex align-items-center gap-2">
                      <span [ngClass]="getMapIcon(map)"
                            [matTooltip]="getToolTip(map)"></span>
                      <span class="name" [matTooltip]="map.description || ''">{{ map.name }}</span>
                    </div>
                    <span class="owner">{{ 'STORE_BROWSER.OWNER_BY' | translate }} <span class="owner-link"
                                                 [matTooltip]="getOwnerFilterTooltip(map)"
                                                 (click)="filterByOwner(map); $event.stopPropagation()">{{ getOwnerName(map) }}</span></span>
                  </div>
                  <div class="thumbnail-actions">
                    @if (!isOwnMap(map) && !isSharedWithMe(map)) {
                      @if (isInLibrary(map)) {
                        <button mat-icon-button
                                [matTooltip]="'STORE_BROWSER.REMOVE_FROM_COLLECTION' | translate"
                                matTooltipPosition="left"
                                [disabled]="processingMapId === map.id"
                                (click)="removeFromLibrary(map); $event.stopPropagation()">
                          @if (processingMapId === map.id) {
                            <mat-spinner diameter="20"></mat-spinner>
                          } @else {
                            <mat-icon class="material-symbols-rounded">remove</mat-icon>
                          }
                        </button>
                      } @else {
                        <button mat-icon-button
                                [matTooltip]="'STORE_BROWSER.ADD_TO_COLLECTION' | translate"
                                matTooltipPosition="left"
                                [disabled]="processingMapId === map.id"
                                (click)="addToLibrary(map); $event.stopPropagation()">
                          @if (processingMapId === map.id) {
                            <mat-spinner diameter="20"></mat-spinner>
                          } @else {
                            <mat-icon class="material-symbols-rounded">add</mat-icon>
                          }
                        </button>
                      }
                    }
                    @if (isUsableTemplate(map)) {
                      <button mat-icon-button
                              [matTooltip]="'STORE_BROWSER.CREATE_FROM_TEMPLATE' | translate"
                              matTooltipPosition="left"
                              (click)="onFirstColumnClick(map); $event.stopPropagation()">
                        <mat-icon class="material-symbols-rounded">control_point_duplicate</mat-icon>
                      </button>
                    } @else {
                      <button mat-icon-button
                              [matTooltip]="'STORE_BROWSER.OPEN_SMAP' | translate"
                              matTooltipPosition="left"
                              (click)="openMap(map); $event.stopPropagation()">
                        <mat-icon class="material-symbols-rounded">open_in_browser</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <mat-nav-list class="list-wrapper">
              <div mat-list-item *ngFor="let map of filteredMaps"
                 class="d-flex justify-content-evenly p-0">
                <span class="row w-100 align-items-start m-0">
                  <span class="col-2 d-flex justify-content-start pt-2">
                    <button mat-icon-button
                            [matTooltip]="getToolTip(map)"
                            matTooltipPosition="above">
                        <span [ngClass]="getMapIcon(map)"></span>
                    </button>
                  </span>
                  <span class="col-6 pe-5 pt-2">
                      <span matLine [matTooltip]="map.description || ''">{{ map.name }}</span>
                      <span class="small d-block">{{ 'STORE_BROWSER.OWNER_BY' | translate }} <span class="owner-name"
                                                           [matTooltip]="getOwnerFilterTooltip(map)"
                                                           (click)="filterByOwner(map); $event.preventDefault(); $event.stopPropagation()">{{ getOwnerName(map) }}</span></span>
                  </span>
                  <span class="col-4 d-flex justify-content-end">
                    @if (!isOwnMap(map) && !isSharedWithMe(map)) {
                      @if (isInLibrary(map)) {
                        <button mat-icon-button
                                [matTooltip]="'STORE_BROWSER.REMOVE_FROM_COLLECTION' | translate"
                                [disabled]="processingMapId === map.id"
                                (click)="removeFromLibrary(map); $event.preventDefault(); $event.stopPropagation()">
                          @if (processingMapId === map.id) {
                            <mat-spinner diameter="20"></mat-spinner>
                          } @else {
                            <mat-icon class="material-symbols-rounded">remove</mat-icon>
                          }
                        </button>
                      } @else {
                        <button mat-icon-button
                                [matTooltip]="'STORE_BROWSER.ADD_TO_COLLECTION' | translate"
                                [disabled]="processingMapId === map.id"
                                (click)="addToLibrary(map); $event.preventDefault(); $event.stopPropagation()">
                          @if (processingMapId === map.id) {
                            <mat-spinner diameter="20"></mat-spinner>
                          } @else {
                            <mat-icon class="material-symbols-rounded">add</mat-icon>
                          }
                        </button>
                      }
                    }
                    @if (isUsableTemplate(map)) {
                      <button mat-icon-button
                              [matTooltip]="'STORE_BROWSER.CREATE_FROM_TEMPLATE' | translate"
                              (click)="onFirstColumnClick(map); $event.preventDefault(); $event.stopPropagation()">
                        <mat-icon class="material-symbols-rounded">control_point_duplicate</mat-icon>
                      </button>
                    } @else {
                      <button mat-icon-button
                              [matTooltip]="'STORE_BROWSER.OPEN_SMAP' | translate"
                              (click)="openMap(map); $event.preventDefault(); $event.stopPropagation()">
                        <mat-icon class="material-symbols-rounded">open_in_browser</mat-icon>
                      </button>
                    }
                  </span>
                </span>
              </div>
            </mat-nav-list>
          }
        }
      </div>
    }
    </div>
  `,
  standalone: true,
  imports: [
    MatListModule,
    CommonModule,
    MatLineModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    SelectInputComponent,
    MatProgressSpinnerModule,
    MatChipsModule,
    CyPreviewComponent,
    TranslatePipe
  ]
})
export class StoreBrowserBottomsheetComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  public maps: GraphMap[] = [];
  public filteredMaps: GraphMap[] = [];
  public isLoading = true;
  public isInitialLoading = true;
  public processingMapId: string | null = null;
  public viewMode: 'list' | 'grid' = 'grid';
  public thumbnailUrls: Map<string, string> = new Map();

  // Live preview state
  public previewData = new Map<string, GraphNode[]>();
  public loadingPreviews = new Set<string>();
  public livePreviewsEnabled = false;
  private intersectionObserver: IntersectionObserver | null = null;
  private observedCards = new Set<string>();

  @ViewChild('searchInput') searchInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('thumbnailGrid') thumbnailGridRef!: ElementRef<HTMLDivElement>;

  private subSink: Subscription = new Subscription();

  filterOptions: { key: string; value: string; isSeparatorAfter?: boolean }[] = [];

  filtersControl = new FormControl('all');
  searchControl = new FormControl('');

  constructor(
    private storeService: StoreService,
    private userService: UserService,
    private tourService: ToursService,
    private router: Router,
    private notificationService: NotificationService,
    private bottomSheetRef: MatBottomSheetRef<StoreBrowserBottomsheetComponent>,
    private dialog: MatDialog,
    private thumbnailService: ThumbnailService,
    private previewService: PreviewService,
    private settingsService: SettingsService,
    private cdr: ChangeDetectorRef,
    private topToolbarStateService: TopToolbarStateService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.filterOptions = [
      { key: 'all', value: this.translate.instant('STORE_BROWSER.FILTER_ALL'), isSeparatorAfter: true },
      { key: 'ownedByMe', value: this.translate.instant('STORE_BROWSER.FILTER_OWNED_BY_ME') },
      { key: 'managedByMe', value: this.translate.instant('STORE_BROWSER.FILTER_MANAGED_BY_ME') },
      { key: 'addedByMe', value: this.translate.instant('STORE_BROWSER.FILTER_ADDED_BY_ME'), isSeparatorAfter: true },
      { key: 'templates', value: this.translate.instant('STORE_BROWSER.FILTER_TEMPLATES') }
    ];

    // Check if live previews are enabled
    const settings = this.settingsService.getLocalStorageSettings();
    this.livePreviewsEnabled = settings.livePreviewsEnabled ?? true;

    // Restore view preference from localStorage
    const savedViewMode = localStorage.getItem('store-browser-view') as 'list' | 'grid';
    if (savedViewMode === 'list' || savedViewMode === 'grid') {
      this.viewMode = savedViewMode;
    }

    this.loadMaps();

    // Debounce search to avoid excessive filtering during rapid typing
    this.subSink.add(
      this.searchControl.valueChanges
        .pipe(debounceTime(150))
        .subscribe(() => this.applyFilters())
    );

    // Skip the initial emission and only react to actual user filter changes
    this.subSink.add(
      this.filtersControl.valueChanges
        .pipe(skip(1))
        .subscribe(() => this.loadMaps())
    );

    // Load user's library initially
    this.storeService.getUserLibrary().subscribe();
  }

  setViewMode(mode: 'list' | 'grid') {
    this.viewMode = mode;
    localStorage.setItem('store-browser-view', mode);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.searchInputRef?.nativeElement) {
        this.searchInputRef.nativeElement.focus();
      }
    }, 1100);

    // Set up intersection observer for live previews
    if (this.livePreviewsEnabled) {
      this.setupIntersectionObserver();
    }
  }

  ngAfterViewChecked() {
    // Observe new cards that haven't been observed yet
    if (this.livePreviewsEnabled && this.intersectionObserver && this.thumbnailGridRef?.nativeElement) {
      const cards = this.thumbnailGridRef.nativeElement.querySelectorAll('.thumbnail-card[data-map-id]');
      cards.forEach((card: Element) => {
        const mapId = card.getAttribute('data-map-id');
        if (mapId && !this.observedCards.has(mapId)) {
          this.observedCards.add(mapId);
          this.intersectionObserver!.observe(card);
        }
      });
    }
  }

  private setupIntersectionObserver(): void {
    this.intersectionObserver = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      { threshold: 0.1, rootMargin: '50px' }
    );
  }

  private handleIntersection(entries: IntersectionObserverEntry[]): void {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const mapId = entry.target.getAttribute('data-map-id');
        if (mapId) {
          this.loadPreviewIfNeeded(mapId);
        }
      }
    });
  }

  private loadPreviewIfNeeded(mapId: string): void {
    if (this.previewData.has(mapId) || this.loadingPreviews.has(mapId)) return;

    this.loadingPreviews.add(mapId);
    this.previewService.getPreview(mapId).subscribe({
      next: (nodes) => {
        if (nodes && nodes.length > 0) {
          this.previewData.set(mapId, nodes);
        }
        this.loadingPreviews.delete(mapId);
        this.cdr.detectChanges();
      },
      error: () => {
        this.loadingPreviews.delete(mapId);
        // Fallback to thumbnail handled in template
      }
    });
  }

  observeCard(element: HTMLElement): void {
    if (this.intersectionObserver && this.livePreviewsEnabled) {
      this.intersectionObserver.observe(element);
    }
  }

  isLoadingPreview(mapId: string): boolean {
    return this.loadingPreviews.has(mapId);
  }

  getPreviewNodes(mapId: string): GraphNode[] | null {
    return this.previewData.get(mapId) || null;
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  private loadMaps() {
    this.isLoading = true;
    const filterKey = this.filtersControl.value;

    const filters: any = {};
    if (filterKey === 'ownedByMe') filters.ownedByMe = true;
    if (filterKey === 'managedByMe') filters.managedByMe = true;
    if (filterKey === 'addedByMe') filters.addedByMe = true;
    if (filterKey === 'templates') filters.templates = true;

    this.storeService.getPublishedMaps(filters).subscribe({
      next: (maps) => {
        this.maps = maps;
        this.applyFilters();
        this.isLoading = false;
        this.isInitialLoading = false;
        // Load presigned URLs for thumbnails
        this.loadThumbnailUrls(maps);
      },
      error: (err) => {
        this.isLoading = false;
        this.isInitialLoading = false;
        this.notificationService.error(this.translate.instant('STORE_BROWSER.ERROR_LOAD'));
      }
    });
  }

  private loadThumbnailUrls(maps: GraphMap[]): void {
    for (const map of maps) {
      if (map.thumbnailUrl && !this.thumbnailUrls.has(map.id)) {
        // Extract key from full URL if needed (handles legacy data)
        let key = map.thumbnailUrl;
        if (key.startsWith('https://')) {
          // Extract just the path part (e.g., smapshots/uuid.png)
          const match = key.match(/\.amazonaws\.com\/(.+)$/);
          if (match) {
            key = match[1];
          }
        }
        this.thumbnailService.getPresignedUrl(key).subscribe(presignedUrl => {
          if (presignedUrl) {
            this.thumbnailUrls.set(map.id, presignedUrl);
            this.cdr.detectChanges();
          }
        });
      }
    }
  }

  getThumbnailUrl(map: GraphMap): string | null {
    return this.thumbnailUrls.get(map.id) || null;
  }

  applyFilters() {
    const searchText = this.searchControl.value?.toLowerCase() || '';

    this.filteredMaps = this.maps.filter((map) => {
      return map.name?.toLowerCase().includes(searchText) ||
             map.description?.toLowerCase().includes(searchText) ||
             this.getOwnerName(map).toLowerCase().includes(searchText);
    });
  }

  getMapIcon(map: GraphMap): string {
    if (map.isTemplate && map.allowViewersToCreateFromTemplate) {
      return 'icon-smap-object-template';
    }
    return 'icon-smap-role-viewer';
  }

  getToolTip(map: GraphMap): string {
    if (map.isTemplate && map.allowViewersToCreateFromTemplate) {
      return this.translate.instant('STORE_BROWSER.TOOLTIP_TEMPLATE');
    }
    return this.translate.instant('STORE_BROWSER.TOOLTIP_VIEW_ONLY');
  }

  isUsableTemplate(map: GraphMap): boolean {
    return map.isTemplate && map.allowViewersToCreateFromTemplate === true;
  }

  getOwnerName(map: GraphMap): string {
    if (map.publisherName) return map.publisherName;
    const unknown = this.translate.instant('STORE_BROWSER.UNKNOWN_OWNER');
    if (!map.owner) return unknown;
    return `${map.owner.name || ''} ${map.owner.lastName || ''}`.trim() || unknown;
  }

  isOwnMap(map: GraphMap): boolean {
    const currentUserId = this.userService.getCurrentUserFromStorage()?.id;
    return map.owner?.id === currentUserId;
  }

  /**
   * Check if the smap is explicitly shared with the current user (via sharedWith).
   * Sharing takes precedence over library addition - users with shared access
   * should not be able to add/remove the smap from their collection.
   * Note: We check sharedWith (not userRoles) because store-added maps also
   * create userRoles entries, but only explicit sharing adds to sharedWith.
   */
  isSharedWithMe(map: GraphMap): boolean {
    const currentUserId = this.userService.getCurrentUserFromStorage()?.id;
    if (!currentUserId || !map.sharedWith) return false;
    // Check if user is in the sharedWith list (explicitly shared with them)
    return map.sharedWith.some(user => user.id === currentUserId);
  }

  isInLibrary(map: GraphMap): boolean {
    return this.storeService.isMapInUserLibrary(map.id);
  }

  onFirstColumnClick(map: GraphMap) {
    if (this.isUsableTemplate(map)) {
      // Open create new map dialog with this template pre-selected
      // Pass the full template object so it can be used temporarily without adding to library
      this.bottomSheetRef.dismiss();
      const ref = this.dialog.open(CreateNewMapDialogComponent, {
        width: '35%',
        autoFocus: 'input',
        data: {
          preSelectedTemplateId: map.id,
          preSelectedStoreTemplate: map
        }
      });
      ref.afterClosed().subscribe((newMap: GraphMap) => {
        if (newMap) {
          this.tourService.activateTourSubject.next(null);
          this.topToolbarStateService.setMapName(newMap.name);
          this.router.navigate(['/dashboard', 'map', newMap.id]);
        }
      });
    } else {
      // For regular smaps, just open/view the smap
      this.openMap(map);
    }
  }

  openMap(map: GraphMap) {
    this.tourService.activateTourSubject.next(null);
    this.topToolbarStateService.setMapName(map.name);
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/dashboard', 'map', map.id]);
  }

  addToLibrary(map: GraphMap) {
    this.processingMapId = map.id;
    this.storeService.addToLibrary(map.id).subscribe({
      next: () => {
        this.processingMapId = null;
        this.notificationService.success(this.translate.instant('STORE_BROWSER.ADDED_TO_COLLECTION', { name: map.name }), { duration: 5000 });
      },
      error: (err) => {
        this.processingMapId = null;
        this.notificationService.error(err.error?.message || this.translate.instant('STORE_BROWSER.ERROR_ADD'));
      }
    });
  }

  removeFromLibrary(map: GraphMap) {
    this.processingMapId = map.id;
    this.storeService.removeFromLibrary(map.id).subscribe({
      next: () => {
        this.processingMapId = null;
        this.notificationService.warning(this.translate.instant('STORE_BROWSER.REMOVED_FROM_COLLECTION', { name: map.name }), { duration: 5000 });
        // If filtering by "In My Collection", reload the list
        if (this.filtersControl.value === 'addedByMe') {
          this.loadMaps();
        }
      },
      error: (err) => {
        this.processingMapId = null;
        this.notificationService.error(err.error?.message || this.translate.instant('STORE_BROWSER.ERROR_REMOVE'));
      }
    });
  }

  getMapCountLabel(): string {
    const searchText = this.searchControl.value?.toLowerCase() || '';
    const filterKey = this.filtersControl.value;

    if (searchText || filterKey !== 'all') {
      return this.translate.instant('STORE_BROWSER.COUNT_FILTERED', { count: this.filteredMaps.length, total: this.maps.length });
    }
    return this.translate.instant('STORE_BROWSER.COUNT_ALL', { total: this.maps.length });
  }

  filterByOwner(map: GraphMap) {
    const ownerName = this.getOwnerName(map);
    this.searchControl.setValue(ownerName);
    // Select the text in search input so user can easily clear with backspace/delete
    setTimeout(() => {
      this.searchInputRef?.nativeElement?.select();
    }, 0);
  }

  getOwnerFilterTooltip(map: GraphMap): string {
    return this.translate.instant('STORE_BROWSER.FILTER_BY_OWNER', { name: this.getOwnerName(map) });
  }

  close() {
    this.bottomSheetRef.dismiss();
  }
}
